import { render, staticRenderFns } from "./QuestionAchived.vue?vue&type=template&id=628292f8&scoped=true&"
import script from "./QuestionAchived.vue?vue&type=script&lang=js&"
export * from "./QuestionAchived.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAchived.vue?vue&type=style&index=0&id=628292f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628292f8",
  null
  
)

export default component.exports